import { type SecondaryCategoryConfigConstructor } from '@webapp/platform/organization-management/entities/SecondaryCategoryConfig'
import { type SecondaryCategoryConfigApiModel } from '../api-models/SecondaryCategoryConfigApiModel'

export const mapSecondaryCategoryConfigApiModel = (
  apiModel: SecondaryCategoryConfigApiModel
): SecondaryCategoryConfigConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  externalId: apiModel.external_id,
  punchoutEmail: apiModel.punchout_email,
})
